import {FieldValues} from "react-hook-form";
import {GET, POST} from "../../../../Hooks/RequestV2";
import {WZListItem, Receiver} from "./types";
import {normalizeWZResponse} from "./helpers";
import {WZApiError} from "../api";

export async function getReceivers(): Promise<Receiver[]> {
    const response = await GET('/user/receivers');

    if (!response.ok) {
        throw new WZApiError(response.status, 'WZ receivers request failed');
    }

    const receivers = await response.json() as unknown;

    return Array.isArray(receivers) ? receivers as Receiver[] : [];
}

export async function filterWZs(values: FieldValues): Promise<WZListItem[]> {
    const response = await POST('/user/wzs/filters', values);

    if (!response.ok) {
        throw new WZApiError(response.status, 'WZ list request failed');
    }

    return normalizeWZResponse(await response.json());
}

export async function searchWZs(values: FieldValues): Promise<WZListItem[]> {
    const response = await POST('/user/wzs/search', values);

    if (!response.ok) {
        throw new WZApiError(response.status, 'WZ search request failed');
    }

    return normalizeWZResponse(await response.json());
}
